import { render, staticRenderFns } from "./IconUserInitials.vue?vue&type=template&id=3fa3f63a"
import script from "./IconUserInitials.vue?vue&type=script&lang=js"
export * from "./IconUserInitials.vue?vue&type=script&lang=js"
import style0 from "./IconUserInitials.vue?vue&type=style&index=0&id=3fa3f63a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports